import {createFileRoute, Navigate} from "@tanstack/react-router";
import {useSelf} from "../../../agent/useSelf.ts";
import {validateAsofSearchParams} from "../../../tstzspan.ts";
import {SuspenseDialog} from "../../../components/SuspenseDialog.tsx";

export const Route = createFileRoute("/_auth/self/timeline")({
    component: SelfTimelinePage,
    validateSearch: validateAsofSearchParams,
});

function SelfTimelinePage() {
    const {data: self, isSuccess} = useSelf();
    const searchParams = Route.useSearch();

    if (!isSuccess) {
        return <SuspenseDialog message="self timeline"/>;
    }

    return <Navigate to="/agent/$id/timeline" params={{id: self.id}}
                     search={searchParams} replace={true}/>
}

